import TicketsResource from '../resources/TicketsResource'

var TicketsService ={
  ticketsResource: TicketsResource,

  login : function (user) {
    return this.ticketsResource.login(user);
  },

  loginWithSessionId : function (sessionId) {
    return this.ticketsResource.loginWithSessionId({sessionId: sessionId});
  },

  loginWithAuthorization : function (authorization) {
    return this.ticketsResource.loginWithAuthorization({authorization: authorization});
  },

  findAllVehicles : function () {
    return this.ticketsResource.findAllVehicles();
  },

  findAllIssueTypes : function () {
    return this.ticketsResource.findAllIssueTypes();
  },

  createTickets : function (issues) {
    return this.ticketsResource.createTickets(issues);
  },

  createInternalTickets : function (issues) {
    return this.ticketsResource.createInternalTickets(issues)
  },

  searchTickets : function (filter) {
    return this.ticketsResource.searchTickets(filter);
  },

  exportTickets : function (filter) {
    return this.ticketsResource.exportTickets(filter);
  },

  findTicketsSituations : function () {
    return this.ticketsResource.findTicketsSituations();
  },

  findVehiclesByPlate : function (plate) {
    return this.ticketsResource.findVehiclesByPlate({plate: plate})
  },

  isPlatesInTickets : function (plate) {
    return this.ticketsResource.isPlatesInTickets([plate]);
  },

  getDueDates : function (links) {
    return this.ticketsResource.dueDates({links:links});
  },

  findAllCustomers : function () {
    return this.ticketsResource.findAllCustomers();
  },

  putOrganization : function (organizationName) {
    return this.ticketsResource.putOrganization({organizationName: organizationName});
  },

  findGeneralStatus : function (){
    return this.ticketsResource.findGeneralStatus();
  },

  searchOrganizations : function (name) {
    return this.ticketsResource.searchOrganizations({name: name});
  },

  findQuestionsByType : function (type) {
    return this.ticketsResource.findQuestionsByType({type: type});
  },

  findCustomerName : function () {
    return this.ticketsResource.findCustomerName();
  },

  findLastCoordinate : function (vehicleId) {
    return this.ticketsResource.findLastCoordinate({vehicleId: vehicleId})
  }

};

export default TicketsService;



// WEBPACK FOOTER //
// ./src/services/TicketsService.js